import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import GlobalStyle from './styles/GlobalStyle';
import QuizContainer from './components/QuizContainer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <QuizContainer />
    </ThemeProvider>
  );
}

export default App; 